import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

const NoEntryIcon: FunctionComponent<Props> = ({ className = '', testId = TEST_ID }) => (
    <svg
        className={`${className}`}
        data-testid={testId}
        fill='none'
        height='12'
        viewBox='0 0 12 12'
        width='12'
        xmlns='http://www.w3.org/2000/svg'>
        <path
            d='M5.872 11.744C2.656 11.744 0 9.12 0 5.872C0 2.624 2.624 0 5.872 0C9.12 0 11.744 2.624 11.744 5.872C11.744 9.12 9.12 11.744 5.872 11.744ZM1.152 5.872C1.152 6.992 1.536 8.016 2.192 8.832L8.816 2.192C8.016 1.536 6.992 1.152 5.872 1.152C3.264 1.152 1.152 3.264 1.152 5.872ZM5.872 10.592C8.48 10.592 10.592 8.48 10.592 5.872C10.592 4.752 10.192 3.712 9.536 2.912L2.912 9.552C3.728 10.208 4.752 10.592 5.872 10.592Z'
            fill='black'
        />
    </svg>
);

export default NoEntryIcon;
